import React, { Component } from 'react';
import { Button, CardBody, Card, Col, Row } from "reactstrap";
import PriceFormatter from '../misc/PriceFormatter';
import * as moment from 'moment';
import 'moment-timezone';
import { ALL_BUS_STATIONS } from "../../containers/bus/BusConfig";
// import axios from "axios";
import { API_URL } from "../../config/Config";
import SaveLoader from "../../components/loader/SaveLoader";

// import { stat } from 'fs';

export default class UserTicketList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }

    checkstatus(status) {
        switch (status) {
            case 1:
                return 'Ticket registration'
            case 2:
                return 'Customer payment'
            case 3:
                return 'Verify'
            case 4:
                return 'Purchase by system'
            case 5:
                return 'Emailed'
            default:
                return 'Ticket Status'
        }
    }

    async DownloadPdf(e) {
        this.setState({ loading: true })
        window.location.replace(API_URL + 'get-ticket/' + e + '?ticket_type=bus');
    }


    render() {
        const ticket = this.props.tikect.BusTicket;
        console.log(this.props.tikect.id)

        return (
            <div className='UserTicketList'>
                {this.state.loading === true && <SaveLoader type="spinningBubbles" color="#43b185" />}
                <Card>
                    <CardBody>
                        <Row className='mt-3 md-5 rtl'>
                            <Col md='3' sm='12'>
                                <div className="ticket-company">
                                    <img src={`/assets/images/bus/${ticket.companyCode}.jpg`} alt={ticket.companyName}
                                        className='ticket-logo' />
                                    <span > {ticket.companyName}</span>
                                    <span >{ticket.busType}</span>
                                    <PriceFormatter
                                        className="item-price ticket-show"
                                        data={ticket.totalPrice}
                                        type="airplane"
                                        date={moment(ticket.departureDateTime, 'dd DD MMM').format("YYYY-M-D")}
                                    />
                                </div>
                            </Col>
                            <Col md='4' sm='12'>
                                <div className="ticket-From">
                                    From :
                                </div>
                                <div className="ticket-departure">
                                    <span className="ticket-departure-airport">
                                        {ALL_BUS_STATIONS.filter(i => i.value === ticket.orginStationCode)[0].label}
                                    </span>
                                    <span className="ticket-departure-airport">
                                        {/* {ticket.AirplaneTicket.departureDate} */}
                                    </span>
                                </div>
                                <div className="ticket-to">
                                    To :
                                </div>
                                <div className="ticket-arrival">
                                    <span className="ticket-departure-airport">
                                        {/* {airports.filter(item => item.iata === ticket.AirplaneTicket.arrivalAirport)[0].name} */}
                                        {ALL_BUS_STATIONS.filter(i => i.value === ticket.destinationStationCode)[0].label}
                                    </span>
                                    <span className="ticket-departure-airport">
                                        {/* {ticket.AirplaneTicket.arrivalDate} */}
                                    </span>
                                </div>
                            </Col>
                            <Col md='3' sm='12'>
                                <div className="ticket-order-date">
                                    <span className="ticket-order-date-span-title">
                                        Order Date :
                                    </span>
                                    <span className="ticket-order-date-span-content">
                                        {ticket.created_at.slice(0, 10)}
                                    </span>
                                </div>
                                <div className="ticket-order-statuse">
                                    <span className="ticket-order-date-span-title">
                                        Selected Seat(s) :
                                    </span>
                                    <span className="ticket-order-date-span-content">
                                        {ticket.selected_seats !== null ?
                                            JSON.parse(ticket.selected_seats).map(seat => seat)
                                            : ' - '}
                                    </span>
                                </div>
                                <div className='ticket-passenger-number'>
                                    {/* <i className="fas fa-users"></i>{ticket.passengers.length} */}
                                </div>
                            </Col>
                            <Col md='2' sm='12'>
                                <div className="ticket-handel-buttons-">
                                    {/* <Button onClick={this.Deletpassenger} ><span className='button-span'><i className="fas fa-ban"></i> Cancelation</span></Button> */}
                                    <Button onClick={this.DownloadPdf.bind(this, this.props.tikect.id)} ><span className='button-span'><i className="fas fa-download"></i>PDF</span></Button>
                                    {/* <Button onClick={this.Deletpassenger} ><span className='button-span'><i className="fas fa-eye"></i>View Details</span></Button> */}
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/user/BusTicketitem.jsx